import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/HomePage.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/page/:id',
    name: 'Page',
    component: () => import('../views/DetailPage.vue')
  },
  {
    path: '/diffcult',
    name: 'Diffcult',
    component: () => import('../views/DiffcultPage.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router